import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Force light (white) theme on app startup
if (typeof document !== "undefined") {
  document.documentElement.classList.remove("dark");
  document.body.classList.remove("dark-mode");
  try {
    localStorage.setItem("theme", "light");
  } catch (_) {
    // ignore storage errors
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

reportWebVitals();
